import React, { useState } from "react";
const estiloSimilares = require("./similares.module.scss").default;
import * as R from "ramda";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons/faCheckSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalMU from "globalMU";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { similares } from "./Similares.stories";

const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type EntitesSimilares = {
  Codigo: string;
  Descricao: string;
  Fornecedor: number;
  Preco: number;
  PrecoVenda: number;
  Referencia: string;
  Unidade: string;
  Unidade1: string;
  UserMessage: string;
};


export type SimilaresProps = {
  codigo: string;
  descricao: string;
  dadosSimilares: PagedMessageResponse<EntitesSimilares>;
  onOk: (entitesSimilares: EntitesSimilares[]) => void;
  corSelecionado: string;
  textoSelecionado: string;
  onPesquisarPaginado: (numeroPagina: number) => void
  foraOrcamento: boolean
};

export const Similares = (props: SimilaresProps) => {
  const [similaresSelecionados, setSimilaresSelecionados] = useState<EntitesSimilares[]>([]);

  const toggleSimilaresSelecionado = (similares) => {
    if (similaresSelecionados.includes(similares)) {
      setSimilaresSelecionados(
        R.filter((e) => e != similares, similaresSelecionados)
      );
    } else {
      setSimilaresSelecionados(similaresSelecionados.concat(similares));
    }
  };

  const detalheProdutoSelecionado = <div className={estiloSimilares.form} id="similares_produtos_detalheProdutoSelecionado">
    <label>Produto</label>
    <div>{props.codigo}</div>
    <label>Descrição</label>
    <div>{props.descricao}</div>
  </div>

  const btnSelecionarTodos = <button
    className={`no-global-button ${estiloSimilares.button_check}`}
    onClick={() => {
      // `?.` obrigatorio: `dadosSimilares` chega undefined no primeiro render (o container
      // usa useState sem valor inicial) e vira {} quando a consulta nao traz similares.
      // O resto do arquivo ja tratava isso (linhas do map e da paginacao), so este ponto
      // ficou desprotegido - e nao era inofensivo por estar dentro do onClick: o React
      // Compiler ica o acesso para a checagem de dependencia do memo cache, que roda no
      // RENDER. Resultado era "Cannot read properties of undefined (reading 'Entities')"
      // derrubando o componente no LimiteDeErroReact. Ver Aprendizado_React.md #React-341.
      const entidades = props.dadosSimilares?.Entities ?? []

      setSimilaresSelecionados(
        entidades.length != similaresSelecionados.length ? entidades : []
      );
    }}
  >
    <FontAwesomeIcon
      color="#3c8ac9"
      className={estiloSimilares.icone_check}
      icon={faCheckSquare}
      fontSize={"23px"}
    />
    Selecionar todos
  </button>

  const tableHead = <div className="_table-header-group">
    <div className="_table-row">
      <div
        className={`_table-cell ${estiloSimilares.tableCellHeader}`}
      >
        Código
      </div>
      <div
        className={`_table-cell ${estiloSimilares.tableCellHeader}`}
      >
        Descrição
      </div>
      <div
        className={`_table-cell ${estiloSimilares.tableCellHeader}`}
        style={{ textAlign: "right" }}
      >
        Unidade
      </div>
      <div
        className={`_table-cell ${estiloSimilares.tableCellHeader}`}
        style={{ textAlign: "right" }}
      >
        Preço Unitário
      </div>
    </div>
  </div>

  const tableBody = <div className="_table-row-group">
    {props.dadosSimilares?.Entities?.map((value) => (
      <div key={value.Codigo}
        className={`_table-row ${similaresSelecionados.includes(value)
          ? estiloSimilares.linhaSelecionada
          : estiloSimilares.linha
          }`}
        onClick={() => {
          toggleSimilaresSelecionado(value);
        }}
        style={
          similaresSelecionados.includes(value)
            ? {
              backgroundColor: props.corSelecionado,
              color: props.textoSelecionado,
            }
            : {}
        }
      >
        <div
          className={`_table-cell ${estiloSimilares.tableCellBody}`}
        >
          {value.Codigo}
        </div>
        <div
          className={`_table-cell ${estiloSimilares.tableCellBody}`}
        >
          {value.Descricao}
        </div>
        <div
          className={`_table-cell ${estiloSimilares.tableCellBody}`}
          style={{ textAlign: "right" }}
        >
          {value.Unidade}
        </div>
        <div
          className={`_table-cell ${estiloSimilares.tableCellBody}`}
          style={{ textAlign: "right" }}
        >
          {globalMU.formatarValorNumerico(value.Preco, 2, true)}
        </div>
      </div>
    ))}
  </div>

  const paginacao = props.dadosSimilares?.PageCount > 1 && (
    <Paginacao
      paginaAtual={props.dadosSimilares?.ActualPage}
      totalPaginas={props.dadosSimilares?.PageCount}
      id="Similares_Paginacao"
      onAlterarListaSelecionada={props.onPesquisarPaginado}
    />
  )

  const btnOk = <button
    className={estiloSimilares.button}
    type="button"
    onClick={() => props.onOk(similaresSelecionados)}
  >
    OK
  </button>

  return (
    <>
      <div>
        {detalheProdutoSelecionado}
        <br />
        <div>
          {btnSelecionarTodos}
        </div>
        <div id="similares_produtos_tabela_Rolavel" className={estiloTabela.containerRolavel}>
          <div className={`_table _w-full _border-collapse ${estiloSimilares.tabelaSimilar}`}>
            {tableHead}
            {tableBody}

            {paginacao}

            {!props.foraOrcamento && <div>
              {btnOk}
            </div>}

          </div>
        </div>
        {<section style={{ marginBottom: "100px" }} />}
      </div>
    </>
  );
};
